import { useRef } from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  XIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  TelegramIcon,
  TelegramShareButton,
} from "react-share";
import { CgClose, CgCopy } from "react-icons/cg";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import toast from "react-hot-toast";

const ShareModal = ({ open, setOpen, url, title, t }) => {
  const iconSize = 36;
  const iconBorderRadius = 6;
  const modalRef = useRef();
  useOnClickOutside([modalRef], () => setOpen(false));

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(`
        ${title}
        ــــــــــــــــــ
        ${url}
      `);
      toast.success(t("copied"));
      setOpen(false);
    }
  };
  return (
    open && (
      <div
        ref={modalRef}
        className="fixed left-1/2 top-1/2 z-50 flex max-[570px]:w-11/12 max-[991px]:w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col rounded-md bg-slate-100 p-4 shadow-md  ring-1 ring-slate-300/70 max-[991px]:min-w-80 max-[991px]:max-w-[500px]"
      >
        <div className="flex justify-between text-slate-600">
          <h2 className="text-lg font-bold">{t("Share")}</h2>
          <CgClose onClick={() => setOpen(false)} />
        </div>
        <div className="flex-grow">
          <h1 className="my-3 divide-x-2 text-slate-600">{title || ""}</h1>
          <div className="flex flex-wrap gap-2 my-3">
            <FacebookShareButton url={url}>
              <FacebookIcon size={iconSize} borderRadius={iconBorderRadius} />
            </FacebookShareButton>
            <TwitterShareButton url={url} title={title || ""}>
              <XIcon size={iconSize} borderRadius={iconBorderRadius} />
            </TwitterShareButton>
            <WhatsappShareButton url={url} title={title || ""}>
              <WhatsappIcon size={iconSize} borderRadius={iconBorderRadius} />
            </WhatsappShareButton>
            <TelegramShareButton url={url} title={title || ""}>
              <TelegramIcon size={iconSize} borderRadius={iconBorderRadius} />
            </TelegramShareButton>

            <EmailShareButton url={url}>
              <EmailIcon size={iconSize} borderRadius={iconBorderRadius} />
            </EmailShareButton>
            <button
              onClick={handleCopy}
              className="flex-grow flex  items-center justify-center  gap-2 bg-[#D11A3C] px-4 py-2 text-white"
            >
              <span>{t("copyLink")}</span>
              <CgCopy />
            </button>
          </div>
        </div>
        {url && (
          <div className="flex">
            <input
              dir="ltr"
              ref={modalRef}
              type="text"
              value={url || ""}
              readOnly
              className="flex-grow px-4 font-bold text-slate-500 focus:outline-0"
            />
          </div>
        )}
      </div>
    )
  );
};

export default ShareModal;
